import React from 'react';
import { GatsbyImage, IGatsbyImageData, GatsbyImageProps } from 'gatsby-plugin-image';
import { StyledImage } from './image.styled';

export interface ImageProps {
  alt?: string;
  url?: string;
  gatsbyImageData?: IGatsbyImageData;
  className?: string;
  objectFit?: GatsbyImageProps['objectFit'];
  objectPosition?: GatsbyImageProps['objectPosition'];
  loading?: 'eager' | 'lazy';
}

const Image = ({
  gatsbyImageData,
  url = '',
  alt = '',
  className = '',
  objectFit,
  objectPosition = '50% 50%',
  loading = 'lazy',
}: ImageProps): JSX.Element => (
  <>
    {gatsbyImageData?.images.fallback?.srcSet ? (
      <GatsbyImage
        image={gatsbyImageData}
        alt={alt}
        className={className}
        objectFit={objectFit}
        objectPosition={objectPosition}
        loading={loading}
      />
    ) : (
      <StyledImage src={url} alt={alt} className={className} loading={loading} />
    )}
  </>
);

export default Image;
